import { createSlice } from "@reduxjs/toolkit";

import { deleteWatchwordsListById, fetchWatchwordsList } from "./actions";

export const INITIAL_STATE = {
  data: [],
};

export const watchwordsListSlice = createSlice({
  name: "list",
  initialState: INITIAL_STATE,
  reducers: {
    resetState: () => INITIAL_STATE,
    setData: (state, { payload = [] }) => {
      state.data = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchWatchwordsList.fulfilled, (state, { payload }) => {
      state.data = payload || [];
    });

    builder.addCase(
      deleteWatchwordsListById.fulfilled,
      (state, { payload: listId }) => {
        state.data = state.data.filter(({ id }) => listId !== id);
      }
    );
  },
});

export const { setData } = watchwordsListSlice.actions;
